import React, { PureComponent } from "react";
import { AccountCardComponent } from "../../../AccountSummary/Pages/Component/CardComponent/CardComponent";
import { Row} from "antd";
import { AccountCardContainer,AlignItemsCenter, IconAlert } from "./style";
import CloseSVG from '../../../../assets/icons/close.svg';

export default class PendingAlert extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      Maintenance_status: true
    };
  }

  closeAlert = () => {
    this.setState({
      Maintenance_status: false
    });
  };

  render() {
    return (
      <AccountCardContainer        
        TopMargin={this.props.TopMargin}
        BottomMargin={this.props.BottomMargin}
      >
        <div>
          <Row>
            <div>
              <AccountCardComponent
                data-test="pendingAlert"
                className={
                  this.state.Maintenance_status == true ? "open" : "close"
                }
              >
                <AlignItemsCenter>
                  <IconAlert type="warning" style={{ display: "inline-block" }} />
                  <p class="pendingAlertContent">{this.props.children}</p>                  
                </AlignItemsCenter>
                <img
                  src={CloseSVG}
                  style={{ margin: " 0px 5px" }}
                  onClick={this.closeAlert}
                  className="mr-icon"
                />
              </AccountCardComponent>
            </div>
          </Row>
        </div>
      </AccountCardContainer>
    );
  }
}
